import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import debounce from "lodash.debounce";


//==================================================================================
//Needs to implement in parent  compnent listener to get the item
//onRecordSelect(item) -> this.$root.$emit('record_selected_from_list_select', item);
//==================================================================================

export default {
  name: 'ElementListSelect',
  components: {
    PaginationComp: require('@/components/paginationComponent/paginationComponent.vue').default,
  },
  props: {
    model: {
      type: Object,
      //required: true
    },
    modelTitle: {
      type: String,
      required: true
    },
    modelList: {
      type: Array,
      required: true
    },
    listDisplayOptions: { //displayField, key
      type: Object,
      required: true
    },
    formHeader: {
      type: String,
      default: ''
    },
    modalSubHeader: {
      type: String,
      default: ''
    },
    disableSelect: {
      type: Boolean,
      default: false
    },
  },
  data: function () {
    return {
      diplaySelectionform: false,
      search: null,
      searched: [],
      currentPage: 1,
      pageSize: 10,
      dataList: [],
      selectedRecord: {},
      elementName: '',
      enablePagination: this.$localStorage.get("list_select_enable_pagination") == 'false' ? false : true,
      lockPagination: true,
    }
  },
  computed: {
    totalPages: function () {
      return this.dataList != null ? Math.ceil(this.dataList.length / this.pageSize) : 0;
    }
  },  
  watch: {
    modelList: function (val) {
      this.dataList = val;    

      this.lockPagination = val != null && val.length > 200 ? true : false;
      if (this.lockPagination == true)
        this.enablePagination = true;

      if (this.enablePagination == false && this.lockPagination != true)
        this.searched = val;
      else
        this.searched = val.slice(0, this.pageSize);
    },
    lockPagination: function (val) {
      if (val == true) {
        this.enablePagination = true;
        if (val && val.length > this.pageSize) 
          this.searched = val.slice(0, this.pageSize);        
        else
          this.searched = val;

        this.onPagination(1);
      }
        
    },
    search: function (val) {
      if (val == null || val == '')
        this.resetTable();
      else
        this.debouncedSearch();
    },
    enablePagination: function (val) {
      if (val != true && this.lockPagination == true) {
        val = true;
        this.enablePagination = true;
        this.$localStorage.set("list_select_enable_pagination", true);
      }
        this.$localStorage.set("list_select_enable_pagination", val);
        this.onPagination();      
    },
    "model.name": function (val) {
      if (val != null)
        this.elementName = this.model.name;
    },
  },
  created() {
    this.$root.$on('maintenance_activity_changed', this.resetSelection)
    this.debouncedSearch = debounce(() => {
      this.searchElement();
    }, 2500);

    this.searched = this.dataList;
  },
  methods: {
    resetSelection() {
      this.elementName = '';
      let temp = {
        typeId: this.selectedRecord.typeId,
        id: -1,
        name: "",
        externalRef: null
      }
      this.selectedRecord = temp;
      this.onRecordSelect(temp, false);
    },
    showHideSelection() {
      this.diplaySelectionform = !this.diplaySelectionform;

      if (this.diplaySelectionform == false)
        document.getElementById('vSelectElement').scrollIntoView({ behavior: 'smooth', block: 'center', });
      else
        document.getElementById('vDisplayElement').scrollIntoView({ behavior: 'smooth' });
    },
    resetTable() {
      this.dataList = this.modelList;
      this.onPagination(1);
    },
    onPagination(pInfo) {
      //console.log(pInfo)
      if (this.enablePagination == false) {
        if (this.search == null || this.search == '')
          this.searched = this.dataList;
        else
          this.searched = this.modelList;
        return;
      }

      if (this.dataList.length == 0 && this.search != null && this.search != '') {
        this.searched = this.dataList;
        return;
      }

      if (pInfo < this.totalPages) {
        let dataFrom = (pInfo - 1) * this.pageSize;
        let dataTo = dataFrom + this.pageSize - 1;
        //console.log("from", dataFrom, "to", dataTo)
        this.searched = this.dataList.slice(dataFrom, dataTo + 1); //data +1 to get "pageSize" number of elements
        this.currentPage = pInfo;
      }
      else if (pInfo == this.totalPages) {
        let dataFrom = (pInfo - 1) * this.pageSize;

        this.searched = this.dataList.slice(dataFrom);
        this.currentPage = pInfo;
      }
      else {
        this.resetTable(1);
      }

    },
    searchElement() {
      this.dataList = this.modelList.filter(o => o.name.includes(this.search));
      //console.log("search lst", this.dataList)
      this.onPagination(1);
    },
    onRecordSelect(item, noChangeEmit) {
      if (!noChangeEmit)
        this.$root.$emit('record_selected_from_list_select', item);

      this.selectedRecord = item;

      if (this.diplaySelectionform)
        this.showHideSelection();
    }
  }
}
